import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./_shared";

export default function CategoriesSection({ data }) {
  const cats = data || {};
  const eyebrow = cats.eyebrow ?? "Two quiet uniforms";
  const heading = cats.heading ?? "Choose your silhouette";
  const shirtsImg =
    cats.shirts_image ??
    "https://customer-assets.emergentagent.com/job_asvasa-premium/artifacts/abm29spg_Shirts.png";
  const kurtasImg =
    cats.kurtas_image ??
    "https://customer-assets.emergentagent.com/job_asvasa-premium/artifacts/zy2bmxo5_Kurta.png";

  const items = [
    { to: "/shop?category=shirts", title: "Shirts", sub: "Six tones, one discipline", img: shirtsImg },
    { to: "/shop?category=kurtas", title: "Short Kurtas", sub: "Floral · Bandhani · Linen", img: kurtasImg },
  ];

  return (
    <section
      className="max-w-7xl mx-auto px-6 md:px-12 pb-20 md:pb-28"
      data-testid="categories-section"
    >
      <Reveal className="text-center mb-12">
        <p className="eyebrow">{eyebrow}</p>
        <h2 className="font-serif-display text-4xl md:text-5xl mt-3">{heading}</h2>
      </Reveal>
      <div className="grid md:grid-cols-2 gap-6 md:gap-10">
        {items.map((c, i) => (
          <Reveal key={c.title} delay={i * 120}>
            <Link
              to={c.to}
              className="group block relative overflow-hidden aspect-[4/5] md:aspect-[3/4] lift-card"
              data-testid={`category-card-${c.title.toLowerCase()}`}
            >
              <img
                src={c.img}
                alt={c.title}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1800ms] ease-out group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#1A1A1A]/85 via-[#1A1A1A]/20 to-transparent" />
              <div className="absolute top-6 left-6 text-[#c3ba9e]/90 text-[10px] tracking-[0.32em] uppercase opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100">
                Shop Now
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-8 md:p-10 text-[#c3ba9e] transform group-hover:translate-y-[-4px] transition-transform duration-700">
                <p className="eyebrow text-[#c3ba9e]/90">{c.sub}</p>
                <h3 className="font-serif-display text-4xl md:text-5xl mt-2">{c.title}</h3>
                <span className="inline-flex items-center gap-2 mt-4 text-[11px] tracking-[0.28em] uppercase border-b border-[#c3ba9e]/40 pb-1 group-hover:border-[#c3ba9e]">
                  Explore <ArrowRight size={14} className="transition-transform duration-500 group-hover:translate-x-1" />
                </span>
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
